<template>
    <div style="width: 100%;">
        <v-row justify="center">
            <v-col cols="12" lg="3" md="5" sm="7">
                <v-card shaped raised>
                    <v-card-title v-if="!$route.query.invite">
                        Passwort zurücksetzen
                    </v-card-title>
                    <v-card-title v-else>
                        Passwort vergeben
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid">
                            <v-text-field
                                    type="password"
                                    label="Passwort"
                                    name="password"
                                    id="password"
                                    :rules="[v => !!v || 'Passwort wird benötigt.']"
                                    v-model="user.password"
                                    prepend-inner-icon="mdi-form-textbox-password" clearable></v-text-field>
                            <v-text-field
                                    type="password"
                                    label="Passwort bestätigen"
                                    :error-messages="passwordMatchError"
                                    name="password_confirmation"
                                    id="password_confirmation"
                                    :rules="[v => !!v || 'Passwort muss bestätigt werden.']"
                                    v-model="user.password_confirmation"
                                    prepend-inner-icon="mdi-form-textbox-password" clearable></v-text-field>
                            <v-btn class="mt-3" color="secondary" block :disabled="!valid" @click="postData">
                                <span v-if="!$route.query.invite">Passwort zurücksetzen</span>
                                <span v-else>Passwort vergeben</span>
                            </v-btn>
                            <v-btn class="mt-3" color="secondary" block text :to="{ name: 'AuthLogin'}">Login</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "auth-reset-password-content",
        data: () => ({
            valid: true,
            user: {
                email: '',
                password: '',
                password_confirmation: '',
            },
            emailRules: [
                v => !!v || 'E-Mail-Adresse wird benötigt.',
                v => /.+@.+\..+/.test(v) || 'E-Mail-Adresse ist ungültig.',
            ],
            checkbox: false,
        }),
        created() {
            if (this.$route.query.email){
                this.user.email = this.$route.query.email;
            }
        },
        computed: {
            passwordMatchError () {
                if (this.user.password && this.user.password_confirmation){
                    return (this.user.password === this.user.password_confirmation) ? '' : 'Die Passwörter müssen übereinstimmen.';
                }
                else{
                    return '';
                }
            }
        },

        methods: {
            ...mapActions({
                resetPassword: 'user/resetPassword'
            }),
            postData() {
                if (this.$refs.form.validate()){
                    const token = this.$route.query.token;
                    this.resetPassword({...this.user, token})
                        .then((response) => {
                            console.log(response.data);
                            this.$router.push({ name: 'AuthLogin'});
                            this.$toast.success('Das Passwort wurde erfolgreich zurückgesetzt.', {
                                timeout: 5000,
                            });
                        }).catch( (error) => {
                        console.log(error);
                        this.$toast.error('Das Passwort konnte nicht zurückgesetzt werden.', {
                            timeout: 5000,
                        });
                    });
                }
            }
        },
    }
</script>

<style scoped>

</style>